<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">Ｗ掲載リスト</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title">処理区分</label>
            <div class="list-input-content">
              <app-radio-label label="出力" groupName="rbg_ProcessType" id="rdb_Export" #rdb_Export [subid]="'rdb_Export'"
                value="1" (change)="eventProcessType_CHANGEHandler()" [(ngModel)]="kymw2600Model.processType"
                [forcedEnabledMode]="'true'" [tabindex]="0">
              </app-radio-label>
              <app-radio-label label="取込" groupName="rbg_ProcessType" id="rdb_Import" #rdb_Import [subid]="'rdb_Import'"
                value="2" (change)="eventProcessType_CHANGEHandler()" [(ngModel)]="kymw2600Model.processType"
                [tabindex]="0" [forcedEnabledMode]="'true'">
              </app-radio-label>
            </div>
          </div>
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">受注コード</label>
              <div class="list-input-content">
                <app-order-code-text-input id="txti_OrderCode" #txti_OrderCode [subid]="'txti_OrderCode'"
                  [catalogIDField]="lbl_DelivCatalogId" [required]="true" [forcedEnabledMode]="'true'" [tabindex]="0"
                  [autofocus]="true" [(ngModel)]="kymw2600Model.orderCode" (ngModelChange)="eventOrderCode_CHANGEHandler()">
                </app-order-code-text-input>
              </div>

              <label class="list-input-title">配達企画回(翌週)</label>
              <div class="list-input-content">
                <input type="text" class="deliv-catalog" id="lbl_DelivCatalogId" #lbl_DelivCatalogId readonly/>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title">部門</label>
              <div class="list-input-content">
                <app-class-code-combo-box id="cmb_ClassCode" [subid]="'cmb_ClassCode'" [forcedEnabledMode]="'true'"
                  [tabindex]="0" [disabled]="kymw2600Model.disabledMediumToFlg" [initFocusItem]="txti_OrderCode"
                  [(ngModel)]="kymw2600Model.classCode" [width]="'185px'">
                </app-class-code-combo-box>
              </div>

              <label class="list-input-title">会員生協</label>
              <div class="list-input-content">
                <app-coop-code-combo-box class="combo-box-normal" id="cmb_CoopCode" [subid]="'cmb_CoopCode'"
                  [forcedEnabledMode]="'true'" [tabindex]="0" [initFocusItem]="txti_OrderCode"
                  [disabled]="kymw2600Model.disabledMediumToFlg" [(ngModel)]="kymw2600Model.coopCode">
                </app-coop-code-combo-box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Execute" class="btn-primary" (click)="eventOutput_CLICKHandler(null)"
            forcedEnabledMode="none" [tabindex]="0" [disabled]="kymw2600Model.disabledExecuteToFlg">実行</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
